import Component from '../core/Component'
import Scroll from '../services/Scroll'

export default class ElementToggle extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.isActive = false
    }

    prepare() {
        Scroll.on('resize-x', this.handleResize)
    }

    destroy() {
        Scroll.off('resize-x', this.handleResize)
    }

    handleResize = () => {
        this.resize()
    }

    open() {
        if (this.isActive) {
            return
        }
        this.isActive = true
        this.element.style.maxHeight = `${this.element.scrollHeight}px`
    }

    close() {
        if (!this.isActive) {
            return
        }
        this.isActive = false
        this.element.style.maxHeight = `0`
    }

    toggle() {
        if (this.isActive) {
            this.close()
        } else {
            this.open()
        }
    }

    resize() {
        if (this.isActive) {
            this.element.style.maxHeight =  `${this.element.scrollHeight}px`
        }
    }
}